module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/PhotographicBackground-15786da67aa356142b55b012bf0921b5.jpg";